// Campus photo for /colleges/the-catholic-university-of-america: CC0 1.0, by w_lemay, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AMcMahon_Hall%2C_Catholic_University_of_America%2C_Washington%2C_DC.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/the-catholic-university-of-america/; credited under the photo.
const photo = {
    "slug": "the-catholic-university-of-america",
    "alt": "McMahon Hall, a stone building with green copper turrets, at the Catholic University of America in Washington, DC",
    "src": "/colleges/the-catholic-university-of-america/campus-1600.webp",
    "srcSmall": "/colleges/the-catholic-university-of-america/campus-800.webp",
    "srcMid": "/colleges/the-catholic-university-of-america/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/the-catholic-university-of-america/og.jpg",
    "title": "McMahon Hall, Catholic University of America, Washington, DC",
    "author": "w_lemay",
    "license": "CC0 1.0",
    "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AMcMahon_Hall%2C_Catholic_University_of_America%2C_Washington%2C_DC.jpg",
    "read": "2026-10-01"
};

export default photo;
